import { render } from "./otherHisVoucher.vue?vue&type=template&id=35add755&scoped=true"
import script from "./otherHisVoucher.vue?vue&type=script&lang=js"
export * from "./otherHisVoucher.vue?vue&type=script&lang=js"

import "./otherHisVoucher.vue?vue&type=style&index=0&id=35add755&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35add755"]])

export default __exports__